import * as storage from './storage';

const key = 'tracking-time';
const tracking = storage.getItem(key);
const get = (name) => {
  const track = tracking;
  if (track) return track[name];
  return {};
};

const start = (name) => {
  const track = tracking || {};
  if (!track[name]) {
    const obj = { start_date: null, end_date: null };
    track[name] = { ...obj, start_date: new Date() };
    storage.setItem(key, track);
  }
};

const stop = (name) => {
  const obj = { start_date: null, end_date: null };
  const track = tracking || { [name]: obj };
  track[name].end_date = new Date();
  storage.setItem(key, track);
};

const reset = (name) => {
  const track = tracking;
  if (track) {
    delete track[name];
    storage.setItem(key, track);
  }
};

export {
  get,
  stop,
  start,
  reset,
};
